import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./Create'))),
    path: '/intel-data/create',
  },
  {
    component: LazyComponent(lazy(() => import('./Update'))),
    path: '/intel-data/update/:id',
  },
];
